import React from 'react';
import { Link } from 'react-router-dom';

import NotFoundImage from '../../../assets/not-found.gif';

import { Container } from './styles';

const NotFound: React.FC = () => {
  return (
    <Container>
      <img src={NotFoundImage} alt="404" />
      <p>Opssss, a página que você solicitou não foi encontrada!</p>
      <button>
        <Link to="/">Voltar para home</Link>
      </button>
    </Container>
  );
};

export default NotFound;
